export const scrollToSection = (elementRef) => {
  if (elementRef.current) {
    elementRef.current.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }
};
